// src/admin/components/FilterSidebar.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";

function FilterSidebar({ initialFilters, onFilter, apiBaseUrl }) {
    const [localFilters, setLocalFilters] = useState(initialFilters);
    const [productOptions, setProductOptions] = useState([]);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(`${apiBaseUrl}/index.php?action=getProducts`);
                
                // ROBUST CHECK: Ensure the response data is an array before mapping it.
                // The API now returns { success: true, data: [...] }
                if (response.data && response.data.success && Array.isArray(response.data.data)) {
                    const options = response.data.data.map(product => ({
                        value: product,
                        label: product
                    }));
                    setProductOptions(options);
                } else {
                    // Handle cases where the API returns an error or incorrect format
                    console.error("API did not return a valid product array:", response.data);
                }

            } catch (error) {
                console.error("Failed to fetch product list:", error);
            }
        };
        fetchProducts();
    }, [apiBaseUrl]);

    // ... the rest of the component remains the same ...

    const handleProductChange = (selectedOptions) => {
        const productValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
        setLocalFilters(prev => ({ ...prev, products: productValues.join(',') }));
    };

    const handleStatusChange = (e) => {
        const { value, checked } = e.target;
        const currentStatuses = [...localFilters.order_status];
        if (checked) {
            currentStatuses.push(value);
        } else {
            const index = currentStatuses.indexOf(value);
            if (index > -1) {
                currentStatuses.splice(index, 1);
            }
        }
        setLocalFilters(prev => ({ ...prev, order_status: currentStatuses }));
    };
    
    const handleSubmit = () => {
        onFilter(localFilters);
    };

    const orderStatusOptions = [
        { label: 'Pending 1/4', value: '1' },
        { label: 'Send to Test 2/4', value: '2' },
        { label: 'Send to Print 3/4', value: '3' },
        { label: 'Shipped 4/4', value: '4' },
        { label: 'Cancelled', value: '0' },
    ];
    
    return (
        <Card>
            <Card.Header as="h5">Filter Contents</Card.Header>
            <Card.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Products</Form.Label>
                        <Select
                            isMulti
                            options={productOptions}
                            onChange={handleProductChange}
                            placeholder="Select products..."
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Order Status</Form.Label>
                        {orderStatusOptions.map(opt => (
                            <Form.Check 
                                type="checkbox"
                                key={opt.value}
                                id={`status-${opt.value}`}
                                label={opt.label}
                                value={opt.value}
                                checked={localFilters.order_status.includes(opt.value)}
                                onChange={handleStatusChange}
                            />
                        ))}
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                        <Form.Label>Order Date Start</Form.Label>
                        <DatePicker 
                            selected={localFilters.start_date ? new Date(localFilters.start_date) : null} 
                            onChange={date => setLocalFilters(prev => ({ ...prev, start_date: date ? date.toISOString().split('T')[0] : '' }))}
                            isClearable
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                        />
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                        <Form.Label>Order Date End</Form.Label>
                        <DatePicker 
                            selected={localFilters.end_date ? new Date(localFilters.end_date) : null} 
                            onChange={date => setLocalFilters(prev => ({ ...prev, end_date: date ? date.toISOString().split('T')[0] : '' }))} 
                            isClearable
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                        />
                    </Form.Group>

                    <div className="d-grid">
                        <Button variant="primary" onClick={handleSubmit}>Apply Filters</Button>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
}

export default FilterSidebar;